import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PRODUCTS_SYNC_FEATURE_KEY } from '../keys';
import { ProductsSyncState } from '../reducers/products-sync.reducer';

const selectProductsSyncState = createFeatureSelector<ProductsSyncState>(PRODUCTS_SYNC_FEATURE_KEY);

export const selectSyncing = createSelector(selectProductsSyncState, (state) => state.syncing);
export const selectLastSyncLog = createSelector(selectProductsSyncState, (state) => state.syncLog);
export const selectProductsSyncLoading = createSelector(selectProductsSyncState, (state) => state.loading);
export const selectProductsSyncLoaded = createSelector(selectProductsSyncState, (state) => state.loaded);
export const selectProductsSyncSaving = createSelector(selectProductsSyncState, (state) => state.saving);
export const selectProductsSyncSaved = createSelector(selectProductsSyncState, (state) => state.saved);
export const selectProductsSyncPolling = createSelector(selectProductsSyncState, (state) => state.polling);
